module.exports = __webpack_public_path__ + "static/logo-c3352c03241685894603918e831b439d.png";